import '~/jssrc/jquery_global';
import '~/jssrc/layout';

import RailsUJS from '@rails/ujs';
RailsUJS.start();  //if (!window._rails_loaded)
